import React from 'react';

import { Info } from 'lucide-react';
import Tooltip from 'react-tooltip-lite';

const FormTooltipIcon = ({ message }) => (
  <Tooltip content={message} direction="right">
    <span className="inline-block ml-2 text-gray-500 cursor-pointer">
      <Info size={16} />
    </span>
  </Tooltip>
);

export default FormTooltipIcon;
